import script from "./PairPriceGraph.vue?vue&type=script&setup=true&lang=ts"
export * from "./PairPriceGraph.vue?vue&type=script&setup=true&lang=ts"

import "./PairPriceGraph.vue?vue&type=style&index=0&id=30f82b5e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30f82b5e"]])

export default __exports__